import './ExperienceLevelTipModal.scss'

import React from 'react'
import { Modal } from 'react-bootstrap'

import {connectModal} from 'redux-modal'

class ExperienceLevelTipModal extends React.Component {
  render() {
    const {show, handleHide} = this.props

    return (
      <Modal show={show} className="ExperienceLevelTip">
        <div className="ExperienceLevelTipModal">
          <div className="ExperienceLevelTipModal__header">
            <div className="ExperienceLevelTipModal__title">
              <h1>Agent Type</h1>
            </div>
            <div className="ExperienceLevelTipModal__close-modal -icon-close" onClick={handleHide}/>
          </div>
          <div className="ExperienceLevelTipModal__body">
            <div className="SubheadPill SubheadPill--success">Experienced</div>
            <p><strong>Experienced agents</strong> have a history of successful client transactions, reflecting their expertise in the market.</p>
            <div className="SubheadPill SubheadPill--info" style={{marginTop: 28}}>Emerging</div>
            <p>The <strong>Emerging agent</strong> path is an exciting opportunity for ambitious agents who are new to our referral platform and open to accelerating their careers with a wide variety of leads.</p>
          </div>
        </div>
      </Modal>
    )
  }
}

export default connectModal({name: 'ExperienceLevelTipModal', destroyOnHide: true})(ExperienceLevelTipModal)
